import React from 'react';
import { useChannelStateContext } from '../../context/ChannelStateContext';

var UnMemoizedWindow = function UnMemoizedWindow(props) {
  var children = props.children,
      _a = props.hideOnThread,
      hideOnThread = _a === void 0 ? false : _a;
  var thread = useChannelStateContext().thread; // If thread is active and window should hide on thread. Return null

  if (thread && hideOnThread) return null;
  return React.createElement("div", {
    className: "str-chat__main-panel"
  }, children);
};
/**
 * A UI component for conditionally displaying a Thread or Channel
 */


export var Window = React.memo(UnMemoizedWindow);